// Static content constants (frontend-only). Images bundled locally.
import { INSTAGRAM_URL as IG, SHOP_BASE as SB, BUY_ONLINE_URL as BO } from "./data";

export const SHOP_BASE = SB;
export const BUY_ONLINE_URL = BO;
export const INSTAGRAM_URL = IG;

export const announcement = "WELCOME TO MAXIMA RACING OILS INDIA WEBSITE";

export const hero = {
  image: "/images/hero-maxima.jpg",
  title: "POWERSPORTS",
};

export const instagramPosts = [
  {
    "image": "/images/Synthetic-CHain-Guard-513ml-F198648634_0432c0f3.jpg",
    "caption": "Contact Clean & Contact Cleaner"
  },
  {
    "image": "/images/Electrical-Contact-Cleaner-F198648025_cb9863fa.jpg",
    "caption": "Pit prep with Maxima"
  },
  {
    "image": "/images/Maxima-DOT-4-Brake-Fluid-16.9oz_0b2bf1b6.jpg",
    "caption": "Suspension dialed in"
  },
  {
    "image": "/images/10045_986596bd.jpg",
    "caption": "Team Maxima gear"
  },
  {
    "image": "/images/FAB1-OIL-FILTER-OIL-SPRAY-F198648019_e0671b86.jpg",
    "caption": "Performance that powers every ride"
  }
];

export const footerInfo = {
  links: [
    { label: "Catalogs", url: BO },
    { label: "Logo", url: BO },
    { label: "Peac Technology", url: BO },
    { label: "FAQ", url: BO },
  ],
  marketedBy: {
    company: "PLUSGROW MERCHANTRY PVT LTD",
    address: ["T 31A MIDC INDUSTRIAL AREA", "HINGNA RD, 440016", "NAGPUR MH, IND"],
    phone: "+91 937 37 88088",
  },
};
